import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=2d5fb76a"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js"
import style0 from "./HeaderDashboard.vue?vue&type=style&index=0&id=2d5fb76a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports